module.exports = __webpack_public_path__ + "static/img/4_2_1.41052b7c.jpg";